import { Component, OnInit, inject } from '@angular/core';
import { ModalContent, ModalRef } from '../../../modal-ref';
import { delay, switchMap } from 'rxjs/operators';
import { ScriptLoaderService } from '../../../../services/script-loader.service';
import { DOCUMENT, NgClass, NgTemplateOutlet, NgStyle, KeyValuePipe } from '@angular/common';
import { WindowService } from '../../../../services/window.service';
import { UserService } from '../../../../services/user/user.service';
import { CommonDataService } from '../../../../services/common-data.service';
import {
  IBuyCryptoMethods,
  UserThirdPartyCryptoService
} from '../../../../services/user/user-third-party-crypto.service';
import { TranslatePipe } from '../../../../services/translation/translate.pipe';
import { BtnComponent } from '../../../../shared/components/btn/btn.component';

declare let mercuryoWidget: any;

@Component({
    selector: 'app-buy-crypto-modal',
    templateUrl: './buy-crypto-modal.component.html',
    styleUrls: ['./buy-crypto-modal.component.scss'],
    imports: [NgClass, NgTemplateOutlet, NgStyle, BtnComponent, KeyValuePipe, TranslatePipe]
})
export class BuyCryptoModalComponent implements OnInit, ModalContent {
  private _scriptLoader = inject(ScriptLoaderService);
  private _window = inject(WindowService);
  private _user = inject(UserService);
  private _common = inject(CommonDataService);
  thirdPartyCrypto = inject(UserThirdPartyCryptoService);
  private _document = inject<Document>(DOCUMENT);


  /**
   * First step
   */
  public isFirstStep = true;

  /**
   * Link to modal window
   */
  public modal: ModalRef;

  constructor() {
    this.thirdPartyCrypto.fetchCryptoAddresses().subscribe();
  }

  ngOnInit(): void {
  }

  /**
   * Data for modal
   */
  get data(): IBuyCryptoMethods {
    return this.modal.options.data;
  }

  /**
   * Go to second step and run widget
   */
  public secondStep(data: IBuyCryptoMethods) {
    this.isFirstStep = false;

    switch (data.PaymentMethod) {
      case this.thirdPartyCrypto.buyCryptoTypes.mercuryo:
        this._initMercuryoWidget(this.thirdPartyCrypto.methods);
        break;
    }
  }

  /**
   * Load mercuryo widget
   * @private
   */
  private _initMercuryoWidget(methods: any[]) {
    this._scriptLoader.load('https://widget.mercuryo.io/embed.2.0.js')
      .pipe(
        delay(100),
        switchMap(() => this.thirdPartyCrypto.widgetId$))
      .subscribe((widgetId: string) => {
        mercuryoWidget = this._window.nativeWindow['mercuryoWidget'] || [];
        mercuryoWidget.run({
          widgetId,
          host: this._document.getElementById('mercuryo-widget'),
          height: '600',
          type: 'buy',
          firstName: this._user.info.first_name ? this._user.info.first_name : '',
          lastName: this._user.info.last_name ? this._user.info.last_name : '',
          email: this._user.info.email,
          currency: this._user.currentWallet.currency,
          currencies: this.thirdPartyCrypto.currencies,
          addressMap: this.thirdPartyCrypto.mapAddress(methods),
          hideAddress: true,
          returnUrl: this._window.nativeWindow.location.origin
        });
      });
  }

}
